import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Row, Col } from 'reactstrap';
import styled from 'styled-components';
const NotesCredit = props => {
  let textNotes='';
  switch(props.type){
    case 'TOPUP':
      textNotes='Please be aware that manual payment method such as, bank transfer, will need 1x24 working hours to be verified. Reach our Customer Service at WhatsApp everyday from 09.00 - 21.00 WIB.';
      break;
    case 'CASHOUT':
      textNotes=' Please allow up to 2 business days for us to process your request.';
      break;
    default:
      textNotes = 'Please be aware that manual payment method such as, bank transfer, will need 1x24 working hours to be verified. Reach our Customer Service at WhatsApp everyday from 09.00 - 21.00 WIB.';
      break;
  }
  return(
    <WrapperNotes>
      <WrapperIconReminder>
        <IconReminder>!</IconReminder>
      </WrapperIconReminder>
      <div>
        <span style={{lineHeight: window.screen.availWidth < 480 && "1.5"}}>{textNotes}</span>
      </div>
    </WrapperNotes>
  )
}

const WrapperNotes = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: 10px;
  padding: 12px;
  align-items: center;
  background-color: #eff8f3;
`;

const WrapperIconReminder = styled.div`
  ${'' /* width: 40px; */}
  height: 34px;
  margin: 2px 12px 2px 0;
  padding: 5.5px 5.6px 5.6px 5.5px;
  background-color: rgba(21,153,83,0.2);
  border-radius: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const IconReminder = styled.div`
  background-color: #159953;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 28px;
  width: 22px;
  height: 22px;
  padding: 9px;
  font-family: 'Nunito-Bold';
`;

export default NotesCredit;